import React from 'react';
import { ReactEditor } from 'slate-react';
import { removeLink } from './helpers/linkHelpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useSnackbar } from 'notistack';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EarthIcon from '@material-ui/icons/Language';
import Link from '@material-ui/core/Link';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';

interface Props {
  href: string;
  editor: ReactEditor;
  className?: string;
}

function LinkPopover({ href, editor, className }: Props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleOpenLink = () => {
    const properHref = !href.includes('http') ? `http://${href}` : href;
    window.open(properHref, '_blank');
  };

  const handleCopy = () => {
    enqueueSnackbar('Copied link to clipboard!');
  };

  return (
    <Paper className={classNames(className, classes.root)}>
      <EarthIcon />
      <Link href={href} onClick={handleOpenLink} className={classes.link} color="secondary">
        {href}
      </Link>
      <CopyToClipboard text={href}>
        <IconButton className={classes.iconButton} onClick={handleCopy}>
          <CopyIcon fontSize="small" />
        </IconButton>
      </CopyToClipboard>
      <Button size="small" className={classes.button} onClick={() => removeLink(editor)}>
        Delete
      </Button>
    </Paper>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body1,
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    cursor: 'pointer',
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  iconButton: {
    padding: theme.spacing(0.5),
  },
  button: {
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: -theme.spacing(0.5),
  },
}));

export default LinkPopover;
